/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { RecipientsDto } from '../../models/recipients-dto';

export interface DeliveryControllerSendEmail$Params {
  id: number;
  status_id: string;
      body: RecipientsDto
}

export function deliveryControllerSendEmail(http: HttpClient, rootUrl: string, params: DeliveryControllerSendEmail$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: BaseResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, deliveryControllerSendEmail.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('status_id', params.status_id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: BaseResponse;
      }>;
    })
  );
}

deliveryControllerSendEmail.PATH = '/delivery/{id}/send-email';
